import { createRoute } from "@tanstack/react-router";

import { HomeContent } from "../components/screens/HomeContent";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomeContent,
});
